// components/Footer.tsx
import { Box, Typography, Link, IconButton } from "@mui/material";
import Grid from '@mui/material/Grid2'; // MUI v6 Grid2
import { COOKIE_POLICY, PRIVACY_POLICY, REFUND_POLICY, TERMS_Of_SERVICE } from "../static/staticContentPage";

const legalLinks = [
    { label: "Cookie Policy", href: `/terms/${COOKIE_POLICY}` },
    { label: "Privacy Policy", href: `/terms/${PRIVACY_POLICY}` },
    { label: "Refund Policy", href: `/terms/${REFUND_POLICY}` },
    { label: "Terms of Service", href: `/terms/${TERMS_Of_SERVICE}` },
];

const ContactLinks = [
    { label: "ecoeatsrsa@gmail.com", href: "mailto:ecoeatsrsa@gmail.com" },
];

const icons = {
    instagram: "https://simpleicons.org/icons/instagram.svg",
    threads: "https://simpleicons.org/icons/threads.svg",
    tiktok: "https://simpleicons.org/icons/tiktok.svg",
};

export const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                position: "relative",
                padding: 4,
                backgroundColor: "transparent",
            }}
            className="pat"
        >
            <Grid container spacing={4} sx={{ justifyContent: 'center', alignContent: 'center' }}>
                {/* Newsletter Sign-up */}
                <Grid sx={{ xs: 10, md: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography
                        variant="h4"
                        gutterBottom
                        sx={{
                            textAlign: {
                                xs: 'center',
                                md: 'left',
                            },
                        }}
                    >
                        Become a Merchant
                    </Typography>
                    <Box display="flex" flexDirection="column" alignItems="flex-start">
                        <Typography
                            variant="body1"
                            gutterBottom
                            sx={{
                                lineHeight: 1.5,
                                wordWrap: 'break-word',
                                textAlign: {
                                    xs: 'center',
                                    md: 'left',
                                },
                            }}
                        >
                            Have a plant-based menu? Join Eco Eats to reach conscious customers, build your community, and boost revenue. Join our waiting list and we’ll be in touch.
                        </Typography>
                    </Box>

                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems={{
                            xs: 'center',
                            md: 'flex-start',
                        }}
                        mt={2}
                    >
                        <a
                            style={{
                                backgroundColor: 'transparent',
                                border: '1px solid #000',
                                color: '#000',
                                padding: '0.75rem 2rem',
                                cursor: 'pointer',
                                borderRadius: '25px',
                                fontSize: '1rem',
                                fontWeight: '400',
                                textAlign: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textDecoration: 'none',
                                width: 'fit-content',
                            }}
                            href='https://docs.google.com/forms/d/e/1FAIpQLSfrmE3fXhLjrkKX7yrlsyPaoWMOXOMztLTOX16T_eA0Px9LjA/viewform'
                        >
                            Join Our Waiting List
                        </a>
                    </Box>
                </Grid>

                {/* Link Sections */}
                <Grid sx={{ xs: 11, md: 8 }}>
                    <Grid
                        container
                        spacing={4}
                        sx={{
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                        }}
                    >
                        {/* Legal */}
                        <Grid
                            sx={{
                                xs: 11,
                                sm: 4,
                                textAlign: { xs: 'center', md: 'left' },
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: { xs: 'center', md: 'left' },
                            }}
                        >
                            <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                sx={{
                                    textAlign: {
                                        xs: 'center',
                                        md: 'left',
                                    },
                                }}
                            >
                                Legal
                            </Typography>
                            {legalLinks.map(({ label, href }) => (
                                <Link href={href} underline="none" display="block" sx={{ mt: 1, }} key={label}>
                                    {label}
                                </Link>
                            ))}
                        </Grid>

                        {/* Contact */}
                        <Grid
                            sx={{
                                xs: 11,
                                sm: 4,
                                textAlign: { xs: 'center', md: 'left' },
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: { xs: 'center', md: 'flex-start' },
                            }}
                        >
                            <Typography variant="subtitle1" fontWeight="bold">
                                Contact Us
                            </Typography>
                            {ContactLinks.map(({ label, href }) => (
                                <Link
                                    href={href}
                                    underline="none"
                                    display="block"
                                    sx={{ mt: 1 }}
                                    key={label}
                                >
                                    {label}
                                </Link>
                            ))}
                        </Grid>

                        {/* Social */}
                        <Grid
                            sx={{
                                xs: 11,
                                sm: 4,
                                textAlign: { xs: 'center', md: 'left' },
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: { xs: 'center', md: 'flex-start' },
                            }}
                        >
                            <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                sx={{
                                    textAlign: {
                                        xs: 'center',
                                        md: 'left',
                                    },
                                }}
                            >
                                Follow Us
                            </Typography>
                            <Box sx={{ display: 'flex' }}>
                                <IconButton
                                    component="a"
                                    href="https://www.instagram.com/ecoeatsrsa/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={icons.instagram} alt="Instagram" style={{ width: 32, height: 32 }} />
                                </IconButton>

                                <IconButton
                                    component="a"
                                    href="https://www.threads.com/@ecoeatsrsa?xmt=AQGzUQCLO1vctmobpXOXJMX7hx6MeQJXRr1zTTb-BHpHggY"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={icons.threads} alt="Threads" style={{ width: 32, height: 32 }} />
                                </IconButton>
                                <IconButton
                                    component="a"
                                    href="https://www.tiktok.com/@ecoeatsrsa?is_from_webapp=1&sender_device=pc"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={icons.tiktok} alt="TikTok" style={{ width: 32, height: 32 }} />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};
